import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

document.write(`
<script
    async
    defer
    src="https://maps.googleapis.com/maps/api/js?key=${environment.googleApiKey}"
></script>
  `);

document.write(`
  <script>
  if(typeof(window.analyticsDataLayer) != 'undefined'){
    window.analyticsDataLayer = {
      push: function(opt) {
        if(typeof(ga) != 'undefined'){
          ga('send', {
            hitType: 'pageview', page: opt.url, title: opt.title
          });
        }
      }
    };
  }
  </script>
`);
//GTM CODE Start
const trackerScriptEle = document.createElement('script');

trackerScriptEle.innerHTML = ` (function (w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', \`${environment['gtmTrackingID']}\`);`

document.head.appendChild(trackerScriptEle)

const iframe = document.createElement('iframe');
iframe.height = "0"
iframe.width = "0"
iframe.style.display = "none",
  iframe.style.visibility = "hidden",
  iframe.src = 'https://www.googletagmanager.com/ns.html?id=' + environment['gtmTrackingID']


const noscript = document.createElement('noscript')
noscript.appendChild(iframe)
document.body.appendChild(noscript);
//GTM code ends

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
